import Admins from '@/services/Rest/Admins';

export default {
	state: {
		admins: {},
		deletedAdmins: {},
		totals: {
			totalAgents: '',
			totalAdmins: ''
		}
	},
	actions: {
		fetchAdmins({ commit, dispatch }) {
			return Admins.getAdmins().then(response => {
				commit('setAdmins', response.data.admins);
				commit('setUsersNumber', response.data);

				return Promise.resolve(response);
			});
		},
		fetchAdmin({ commit, dispatch }, id) {
			return Admins.getAdmin(id);
		},
		updateAdmin({ commit, dispatch }, admin) {
			return Admins.updateAdmin(admin).then(
				response => { return Promise.resolve(response); },
				error => { return Promise.reject(error); }
			);
		},
		deleteAdmin({ commit, dispatch }, data) {
			return Admins.deleteAdmin(data);
		},
		fetchDeletedAdmins({ commit, dispatch }) {
			return Admins.getDeletedAdmins().then(response => {
				commit('setDeletedAdmins', response.data.admins);
				commit('setUsersNumber', response.data);

				return Promise.resolve(response);
			});
		},
		restoreAdmin({ commit, dispatch }, data) {
			return Admins.restoreAdmin(data);
		},
		destroyAdmin({ commit, dispatch }, data) {
			return Admins.destroyAdmin(data);
		},
		fetchNewActiveAdmins({ commit, dispatch }, data) {
			return Admins.getSortedActiveAdmins(data).then(response => {
				commit('setAdmins', response.data.admins);

				return Promise.resolve(response);
			});
		},
		fetchNewDeletedAdmins({ commit, dispatch }, data) {
			return Admins.getSortedDeletedAdmins(data).then(response => {
				commit('setDeletedAdmins', response.data.admins);

				return Promise.resolve(response);
			});
		}
	},
	mutations: {
		setAdmins(state, data) {
			state.admins = data;
		},
		setDeletedAdmins(state, data) {
			state.deletedAdmins = data;
		},
		setUsersNumber(state, data) {
			state.totals.totalAgents = data.total_agents;
			state.totals.totalAdmins = data.total_admins;
		}
	},
	getters: {
		getAdmins(state) {
			return state.admins;
		},
		getDeletedAdmins(state) {
			return state.deletedAdmins;
		},
		getUsersNumberFromAdmins(state) {
			return state.totals;
		}
	}
};
